import { UserDTO } from 'src/app/interfaces/base-entity';

/** Clave de storage del usuario de sesión SST (cifrado). */
export const SESSION_USER_STORAGE_KEY = '59CDBBDF-F7C6-4AFF-97F1-D7F0085AD761';

/** Resuelve el identificador de sesión (API devuelve `identityId`; FE histórico usa `oidB2C`). */
export function resolveSessionUserId(user: UserDTO | null | undefined): string | undefined {
  return user?.identityId ?? user?.oidB2C;
}

/** Alinea `identityId` y `oidB2C` para consumo consistente en toda la app. */
export function normalizeSessionUser(user: UserDTO | null | undefined): UserDTO | undefined {
  if (!user) {
    return undefined;
  }

  const identityId = resolveSessionUserId(user);
  if (!identityId) {
    return user;
  }

  return { ...user, identityId, oidB2C: identityId };
}

export function isSameSessionUser(
  resourceUserId: string | undefined,
  sessionUser: UserDTO | null | undefined
): boolean {
  const sessionUserId = resolveSessionUserId(sessionUser);
  if (!resourceUserId || !sessionUserId) {
    return false;
  }
  return resourceUserId.toLowerCase() === sessionUserId.toLowerCase();
}
